import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// Assets
import { ReactComponent as Homeicon } from "./icons/HomeIcon.svg";
import { ReactComponent as PinnedIcon } from "./icons/pinedIcon.svg";
import { ReactComponent as SportsIcon } from "./icons/SportsIcon.svg";
import { ReactComponent as CasinoIcon } from "./icons/CasinoIcon.svg";
import { ReactComponent as AccountIcon } from "./icons/AccountIcon.svg";
import { ReactComponent as InPlayIcon } from "./icons/InplayIcon.svg";
import CasinoGame from "./icons/CasinoGamesGif.gif";

import "./BottomNavigation.css";
// Styles

import { ExchangeContexts } from "../../context/ExchangeContext";
import User, { User_Context } from "../../context/User";
import { LazyLoadImage } from "react-lazy-load-image-component";

function BottomNavigation() {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location || {};
    const { setInplayRef ,setShowProfileBox} = useContext(ExchangeContexts);
    const {User}=useContext(User_Context);
    const [activeTab, setActiveTab] = useState("sports");

    useEffect(() => {
        switch (pathname) {
            case "/":
                setActiveTab("sports");
                break;
            case "/satta":
                setActiveTab("satta");
                break;
            case "/exchange":
                setActiveTab("exchange");
                break;
            case "/casino":
            case "/casino-select":
                setActiveTab("casino");
                break;
            case "/exchange/m-pinned":
                setActiveTab("multi-pinned");
                break;
            case "/profile":
                setActiveTab("profile");
                break;
            case "/inplay":
                setActiveTab("inplay");
                break;
            default:
                setActiveTab("");
                break;
        }

        if (pathname.includes("exchange/markets")) {
            setActiveTab("exchange");
        }
    }, [pathname]);

    const handleInplay = () => {
        if (pathname !== "/") {
            navigate("/");
        }
        setInplayRef("Inplay");
    };


    // handle profile click
    const handleProfileClick=()=>{
        if(User.token){
            if(activeTab=="profile"){
                setActiveTab("");
            }else{
                setActiveTab("profile")
            }
            setShowProfileBox((prev)=>!prev)
        }
    }

    return (
        <div className="MobileFooter-outer">
            <div className="MobileFooter_mobileFooter depo-foot">
               
                <div
                    onClick={() => navigate("/",{state:{sportData:{sportName:"cricket"}}})}
                    role="button"
                    className={`MobileFooter_footerItem ${activeTab === "sports" ? "active" : ""}`}>
                    <a className="MobileFooter_itemContent" role="button">
                        <SportsIcon className="MobileFooter_icon" />
                        <span className="MobileFooter_label">All Sports</span>
                    </a>
                </div>

                <div
                    onClick={() => navigate("/inplay")}
                    role="button"
                    className={`MobileFooter_footerItem ${activeTab === "inplay" ? "active" : ""}`}>
                    <a className="MobileFooter_itemContent" role="button">
                        <InPlayIcon className="MobileFooter_icon" />
                        <span className="MobileFooter_label">In-play</span>
                    </a>
                </div>

                {/* <div
                    onClick={() => navigate("/")}
                    role="button"
                    className={`MobileFooter_footerItem ${activeTab === "home" ? "active" : ""}`}>
                    <a className="MobileFooter_itemContent" role="button">
                        <Homeicon className="MobileFooter_icon newfix" />
                        <span className="MobileFooter_label">Home</span>
                    </a>
                </div> */}

                <div
                    onClick={() => navigate("/exchange/m-pinned", { state: { Category: "SLOT" } })}
                    role="button"
                    className={`MobileFooter_footerItem ${activeTab === "multi-pinned" ? "active" : ""}`}>
                    <a className="MobileFooter_itemContent" role="button">
                        <PinnedIcon className="MobileFooter_icon newfix" />
                        <span className="MobileFooter_label">Pinned</span>
                    </a>
                </div>

                <div
                    onClick={handleProfileClick}
                    role="button"
                    className={`MobileFooter_footerItem ${activeTab === "profile" ? "active" : ""}`}>
                    <a className="MobileFooter_itemContent" role="button">
                        <AccountIcon className="MobileFooter_icon newfix" />
                        <span className="MobileFooter_label">Account</span>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default BottomNavigation;
